﻿import { saveAs } from 'file-saver';

window.saveAs = saveAs;